module.exports = __webpack_public_path__ + "static/media/tidal-logo-white.d271f2ed.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/promos/tidal/tidal-logo-white.svg
// module id = 308
// module chunks = 0